<template>
    <div :class="isMobile ? '' : 'container'" style="margin: auto">
        <!-- ------------------------ -->
        <!-- Configuration parameters -->
        <!-- ------------------------ -->
        <template v-if="configuration">
            <div v-if="source == 'viewerApp'" class="text-end">
                {{ configuration.updated_at_formatted }}
            </div>
            <div class="card my-3">
                <div class="card-header">
                    <strong>{{ $t("s4_config_resume") }}:</strong>
                </div>

                <div
                    class="card-body d-flex"
                    :class="window.width > 700 ? 'flex-row' : 'flex-column'"
                >
                    <div class="mr-5 mt-3">
                        <p
                            class="text-left"
                            v-for="parameter in configuration.familyParameters"
                            :key="parameter.attribute.id"
                        >
                            <span class="bold">{{ parameter.attribute.name }}</span>
                            : {{ parameter.valueString }}
                        </p>

                        <template
                            v-if="
                                !b66b67helper.is66or67() ||
                                b66b67helper.isTramoComun()
                            "
                        >
                            <p
                                class="text-left"
                                v-for="parameter in configuration.commonMainElementParameters"
                                :key="parameter.attribute.id"
                            >
                                <span class="bold">{{ parameter.attribute.name }}</span>
                                : {{ parameter.valueString }}
                            </p>
                        </template>
                    </div>

                    <!-- --------------------------------------------- -->
                    <!-- Parametros mainElement: -->
                    <!-- --------------------------------------------- -->
                    <div
                        v-if="
                            configuration.mainElementParameters &&
                            Object.keys(configuration.mainElementParameters).length
                        "
                    >
                        <div
                            v-for="(
                                element, key, index
                            ) in configuration.mainElementParameters"
                            :key="index"
                        >
                            <div class="mt-2">
                                <div
                                    v-for="parameter in element"
                                    :key="parameter.attribute.id"
                                >
                                    <p
                                        class="text-left"
                                        v-if="
                                            !(
                                                b66b67helper.is66or67() &&
                                                (parameter.attribute.id ==
                                                    'metros_por_tramo' ||
                                                    parameter.attribute.id ==
                                                        'distancia_soportes') &&
                                                b66b67helper.isTramoComun() && b66b67helper.mustShowDistanciaEntreSoportes()
                                            ) &&
                                            !(
                                                configuration.familyParameters['gama'].value.id == '50t' &&
                                                parameter.attribute.id == 'numero_mecanismos' &&
                                                configuration.market.id =='chile'
                                            ) &&
                                            !(
                                                configuration.familyParameters['gama'].value.id == '50t' &&
                                                parameter.attribute.id == 'numero_placas' &&
                                                configuration.market.id !='chile'
                                            )
                                        "
                                    >
                                        <span class="bold">{{
                                            parameter.attribute.name
                                        }}</span>
                                        : {{ parameter.valueString }}
                                    </p>
                                </div>
                                <!-- <p
                                    class="text-left"
                                    v-for="parameter in element"
                                    :key="parameter.attribute.id"
                                >
                                    <span class="bold">{{
                                        parameter.attribute.name
                                    }}</span>
                                    : {{ parameter.valueString }}
                                </p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <savedConfigBomComponent :savedConfig="configuration"></savedConfigBomComponent>
            <technicalFiles :configuration="configuration"></technicalFiles>

        </template>

    </div>
</template>

<style scoped lang="scss">
.selected_img {
    display: block !important;
}

.leftmiddleIfPhone_centerMiddleIfPC {
    text-align: center;
    vertical-align: middle;
}

.col2 {
    width: 500px;
    text-align: left;
    margin-left: 50px;
    vertical-align: middle;
}

.titol {
    text-align: left;
    margin-top: 50px;
    margin-bottom: 25px;
}
.bullet {
    width: 40px;
    height: 40px;
}
.text_green {
    color: lawngreen;
    font-weight: bold;
}
.bold {
    font-weight: bold;
}
.left {
    text-align: left;
}
.marginLeft {
    margin-left: 30px;
}
.bulletRotated {
    -ms-transform: rotate(90deg); /* IE 9 */
    -webkit-transform: rotate(90deg); /* Safari 3-8 */
    transform: rotate(90deg);
}
.estil_radio {
    width: 20px;
    height: 20px;
}
.estil_checkbox {
    width: 20px;
    height: 20px;
}

.btnCarroCompra {
    margin: 50px 30px 100px 30px;
}

@media (max-width: 767px) {
    .hideIfPhone {
        display: none;
        visibility: hidden;
    }
    .leftmiddleIfPhone_centerMiddleIfPC {
        text-align: left;
        vertical-align: middle;
    }
}
</style>


<script>
import { app } from "../../application.js";
import savedConfigBomComponent from "./savedConfigBom.vue";
import technicalFiles from "../results/technicalFiles.vue";
import B66B67Helper from "../../services/b66b67helper.js";

export default {
    name: "savedConfigDetailsComponent",
    props: {
        configuration: Object,
        source: {
            type: String,
            default: "app"
        }
    },

    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        window.scrollTo(0, 0);
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    beforeMount() { },
    data() {
        return {
            app: app,
            count: 1,
            b66b67helper: new B66B67Helper(app),
            window: { width: 0, height: 0 }
        };
    },

    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
    },
    computed: {
        isMobile: function () {
            let a = this.window.width < 600;
            return a;
        }
    },
    watch: {
        configuration(newValue) {
            this.count++
            this.b66b67helper.configuration = newValue
        }
    },
    components: {
        savedConfigBomComponent,
        technicalFiles
    }
};
</script>




